<div class='layout-wrapper'>
  <div class='layout-content-wrapper'>
    <div class='layout-topbar' [ngClass]='{ hiddenNav: !menuActive }'>
      <div class='topbar-left'>
        <a class='menu-button' (click)='onMenuButtonClick()'>
          <i [class]="menuActive ? 'pi pi-chevron-left' : 'pi pi-chevron-right'"></i>
        </a>
        <img
          id='logo-mobile'
          alt='ziselsberger-logo'
          class='mobile-logo'
          src='assets/images/logo.svg'
        />
      </div>
      <div class='topbar-right' [ngClass]='{ user: menuActive }'>
        <div class="user-menu" style="position:relative;">
          <button class="user-menu-toggle" (click)="userMenuOpen = !userMenuOpen">
            <i class="pi pi-user"></i>
            <span>{{ username }}</span>
            <i class="pi pi-chevron-down" style="font-size:0.65rem;"></i>
          </button>
          @if (userMenuOpen) {
            <div class="user-menu-dropdown">
              @for (item of items; track item.value) {
                <div (click)='logout()' class="user-menu-item">{{ item.value }}</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div
      class='layout-mask'
      [ngClass]="{ 'layout-mask-active': menuActive }"
      (click)='onMaskClick()'
    ></div>

    <div class='layout-content' [ngClass]='{ hiddenNav: !menuActive }'>
      <router-outlet></router-outlet>
    </div>
  </div>
  <section class='container'>
    <aside>
      <app-sidebar [menuActive]='!menuActive'></app-sidebar>
    </aside>
  </section>
</div>
